import React from 'react'
import './PersonalCare.css'
import Header from '../../components/Header/Header'
import NavBar from '../../components/NavBar/NavBar'
import Footer from '../../components/Footer/Footer'
import ItemList from '../../components/ItemList/ItemList'
import data from '../../screens/Home/herbal.json'

const PersonalCare = () => {
  return (
    <div>
    <Header />
    <NavBar/>
    <div style={{ marginTop: "5%" }}>
      <ItemList data={data} />
    </div>
    <Footer/>
  </div>
  )
}

export default PersonalCare